import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import ReceiptItemFooterStyle from './css/ReceiptItemFooterStyle'
import ReceiptController from '../receipt/ReceiptController'
import ReceiptsListController from '../receiptslist/ReceiptsListController'
import InvoiceController from '../../invoice/invoice/InvoiceController'
import { appContext } from '../../../App'
import { receiptItemControllerContext } from './ReceiptItemController'
import { selectPaperSizeForm } from './forms/SelectPaperSizeForm'
import ModalWindow from '../../layout/modalwindow/ModalWindow'

function ReceiptItemFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const receiptItemController = useContext(receiptItemControllerContext)
  const { receipt, receiptFor, getReceiptById } = receiptItemController
  const setPaperSize = receiptItemController.paperSize[1]

  const showMessageBoxReceiptNotFound = async () => {
    const onClick = async () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      setContent(<ReceiptsListController />)
    }

    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header='Receipt Not Found'
        footer={null}
        width='25'
        height='20'>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Receipt file/record no longer exist!</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickEdit = async (e) => {
    const rec = await getReceiptById(app, receipt._id)
    if (rec) {
      receipt.receipt_for.item = receiptFor
      setContent(<ReceiptController receipt={receipt} />)
    } else showMessageBoxReceiptNotFound() 
  }

  const onClickPrint = async (e) => {
    const rec = await getReceiptById(app, receipt._id)
    if (rec) {
      const cbf = (res) => { setPaperSize(res) }
      selectPaperSizeForm(cbf)
    } else showMessageBoxReceiptNotFound()
  }

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='action-btn-container'>
          <button
            id='edit-receipt-button'
            onClick={onClickEdit}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='edit'/>&nbsp;Edit...
          </button>
          <button
            id='print-receipt-button'
            onClick={onClickPrint}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print...
          </button>
          <button
            id='back-receipt-button'
            onClick={() => setContent(<ReceiptsListController />) }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Receipt's List
          </button>
          {
            (receipt.receipt_for.item_name === 'Invoice')
            ? <button
                id='add-new-invoice-button'
                onClick={() => setContent(<InvoiceController />) }
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='plus'/>&nbsp;New Invoice
              </button>
            : null
          }
        </div>
      </div>
      <ReceiptItemFooterStyle signed_in={app.client.signed_in} />
    </ContentFooter>
  )
}

export default React.memo(ReceiptItemFooter)